import { Workbook } from 'exceljs'
import { triggerDownload } from './download.js'

export interface SpreadsheetCell {
    value:string | number | boolean | null;
    formula:string;
}

export type CellValue = string | number | boolean | null | SpreadsheetCell

export interface SpreadsheetSheet {
    name:string;
    headers?:string[];
    rows:CellValue[][];
}

export interface SpreadsheetOptions {
    sheets:SpreadsheetSheet[];
    filename?:string;
}

export interface CsvOptions {
    headers?:string[];
    rows:(string | number | boolean | null)[][];
    filename?:string;
}

function quoteCsvValue (val:string | number | boolean | null):string {
    if (val === null || val === undefined) return ''
    const s = String(val)
    if (s.includes(',') || s.includes('"') || s.includes('\n')) {
        return '"' + s.replace(/"/g, '""') + '"'
    }
    return s
}

export function buildCsvString (
    headers:string[] | undefined,
    rows:(string | number | boolean | null)[][]
):string {
    const lines:string[] = []
    if (headers && headers.length > 0) {
        lines.push(headers.map(quoteCsvValue).join(','))
    }
    for (const row of rows) {
        lines.push(row.map(quoteCsvValue).join(','))
    }
    return lines.join('\n')
}

export function exportCsv (options:CsvOptions):void {
    const csv = buildCsvString(options.headers, options.rows)
    const blob = new Blob([csv], { type: 'text/csv' })
    const filename = options.filename ?? 'export.csv'
    triggerDownload(blob, filename)
}

export async function exportXlsx (options:SpreadsheetOptions):Promise<void> {
    const workbook = new Workbook()

    for (const sheet of options.sheets) {
        const ws = workbook.addWorksheet(sheet.name)
        if (sheet.headers && sheet.headers.length > 0) {
            ws.addRow(sheet.headers)
        }
        for (const row of sheet.rows) {
            const rowData = row.map(cell => {
                if (
                    cell !== null &&
                    typeof cell === 'object' &&
                    'formula' in cell
                ) {
                    return { formula: (cell as SpreadsheetCell).formula }
                }
                return cell as string | number | boolean | null
            })
            ws.addRow(rowData)
        }
    }

    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer as ArrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const filename = options.filename ?? 'export.xlsx'
    triggerDownload(blob, filename)
}
